import { CheckOutlined, PlusOutlined } from '@ant-design/icons';
import { Drawer, Modal, ScrollArea } from '@mantine/core';
import { Tabs } from 'antd';
import NotifyFailure from 'components/Atoms/LoyaltyStore/ChangeGiftStep/Notify/failure';
import NotifySuccess from 'components/Atoms/LoyaltyStore/ChangeGiftStep/Notify/success';
import ModalDetailUseGift from 'components/Atoms/LoyaltyStore/DetailUseGiftModal';
import { RoutesV1 } from 'constants/appRoutes';
import { isNullOrEmpty } from 'functions';
import useDevice from 'hooks/useDevice';
import { uniqueId } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { formatTimeString } from 'utils';
import { TabsStyle } from './style';

const MyGiftModal = ({ myGift, opened, handleOpened, reloadData }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useDevice().isMobile;

  const [tabActive, setTabActive] = useState('1');

  // avaiable: type == 1
  // delivering: type == 2
  // used: type == 3
  // vendorName = bvl_quabv - quà bảo việt : type == 5
  const [typeGift, setTypeGift] = useState({
    type: 0,
    data: {},
  });

  const [statusGift, setStatusGift] = useState({
    isOpen: false,
    isSuccess: false,
    isFail: false,
    isLoading: false,
    reason: '',
  });

  const handleClose = () => {
    setStatusGift((prev) => {
      return {
        ...prev,
        isOpen: false,
      };
    });
    setTypeGift({ type: 0, data: {} });
  };
  const handleShowGift = () => {
    navigate(`/${RoutesV1.loyaltyStore}#openGift=true`);
  };

  const autoHideMessage = useCallback(
    () =>
      setTimeout(() => {
        setStatusGift({
          isOpen: true,
          isSuccess: false,
          isFail: false,
          isLoading: false,
          reason: '',
        });
        // setTypeGift({ type: 0, data: {} });
      }, 5000),
    [myGift]
  );

  useEffect(() => {
    if (typeGift.type !== 0) {
      setStatusGift((prev) => {
        return {
          ...prev,
          isOpen: true,
        };
      });
    }
  }, [typeGift.type]);

  useEffect(() => {
    let hide;
    if (statusGift.isSuccess || statusGift.isFail) {
      hide = autoHideMessage();
    }
    return () => {
      clearTimeout(hide);
    };
  }, [statusGift]);

  useEffect(() => {
    if (location.hash.includes('open=used')) {
      setTabActive('2');
    }
  }, [location]);

  return (
    <>
      {isMobile ? (
        <Drawer
          opened={opened}
          onClose={() => handleOpened(false)}
          size='xl'
          position='right'
          withCloseButton={false}
          className='pt-4'
          zIndex={600}
        >
          <div className='flex items-center px-5 pt-5'>
            <PlusOutlined
              onClick={() => handleOpened(false)}
              className='mr-4 cursor-pointer'
              style={{
                color: '#000',
                fontSize: 24,
              }}
              rotate={45}
            />
            <p className='font-averta-bold text-20px text-black'>Quà của tôi</p>
          </div>

          <div className='px-5 pb-5'>
            <TabsStyle>
              <Tabs defaultActiveKey={tabActive} key={tabActive} onChange={setTabActive}>
                <Tabs.TabPane tab='Chưa sử dụng' key='1'>
                  <ScrollArea style={{ height: '80vh' }}>
                    <div>
                      <p className='pb-2 font-averta-bold'>Có thể sử dụng</p>
                      <div className=''>
                        {myGift.myGift.length > 0
                          ? myGift.myGift.map((i, index) => {
                              if (i?.eGift && new Date(i?.eGift?.expiredDate) >= new Date()) {
                                return (
                                  <ItemGift
                                    data={i}
                                    key={uniqueId()}
                                    handleTypeGift={setTypeGift}
                                  />
                                );
                              } else if (i?.eGift === null) {
                                return (
                                  <ItemGift
                                    data={i}
                                    key={uniqueId()}
                                    handleTypeGift={setTypeGift}
                                  />
                                );
                              }
                            })
                          : null}
                      </div>
                    </div>
                    <hr />
                    <div>
                      <p className='pt-2 font-averta-bold'>Không thể sử dụng</p>
                      <div className=''>
                        {myGift.myGift.length > 0
                          ? myGift.myGift.map((i) => {
                              if (i?.eGift && new Date(i?.eGift?.expiredDate) < new Date()) {
                                return (
                                  <ItemGift
                                    used
                                    data={i}
                                    key={uniqueId()}
                                    handleTypeGift={setTypeGift}
                                  />
                                );
                              }
                            })
                          : null}
                      </div>
                    </div>
                  </ScrollArea>
                </Tabs.TabPane>
                <Tabs.TabPane tab='Đã sử dụng' key='2'>
                  <ScrollArea style={{ height: '80vh' }}>
                    <div className='flex flex-wrap'>
                      {myGift.used.length > 0
                        ? myGift.used.map((i) => (
                            <ItemGift used data={i} key={uniqueId()} handleTypeGift={setTypeGift} />
                          ))
                        : null}
                    </div>
                  </ScrollArea>
                </Tabs.TabPane>
              </Tabs>
            </TabsStyle>
          </div>

          {/* modal 2 for use gift */}
          <ModalDetailUseGift
            statusGift={statusGift}
            type={typeGift.type}
            data={typeGift.data}
            handleClose={handleClose}
            handleStatusGift={setStatusGift}
            reloadData={reloadData}
          />
          {/* success */}
          <NotifySuccess
            handleShowGift={handleShowGift}
            isSuccess={statusGift.isSuccess}
            name={typeGift.data?.giftTransaction?.giftName || ''}
            quantity={typeGift.data?.giftTransaction?.quantity || 1}
          />
          {/* falure */}
          <NotifyFailure
            handleClose={() => {
              setStatusGift((prev) => {
                return {
                  ...prev,
                  isFail: false,
                };
              });
            }}
            isFail={statusGift.isFail}
            name={typeGift.data?.giftTransaction?.giftName || ''}
            quantity={typeGift.data?.giftTransaction?.quantity || 1}
            resson={statusGift.reason}
          />
        </Drawer>
      ) : (
        <Modal
          size={870}
          centered
          opened={opened}
          onClose={() => handleOpened(false)}
          withCloseButton={false}
          radius={8}
          padding={0}
          classNames={{
            body: 'overflow-hidden',
            modal: 'overflow-hidden',
          }}
        >
          <div className='relative h-full w-full overflow-hidden rounded-lg'>
            <div className='flex justify-between px-5 pt-5'>
              <p className='font-averta-bold text-20px text-black'>Quà của tôi</p>
              <PlusOutlined
                onClick={() => handleOpened(false)}
                className='m-2 ml-4 mr-0 cursor-pointer'
                style={{
                  color: '#000',
                  fontSize: 24,
                }}
                rotate={45}
              />
            </div>
            <div className='px-5 pb-5'>
              <TabsStyle>
                <Tabs defaultActiveKey={tabActive} key={tabActive} onChange={setTabActive}>
                  <Tabs.TabPane tab='Chưa sử dụng' key='1'>
                    <ScrollArea style={{ height: '400px' }}>
                      <div>
                        <p className='pb-2 font-averta-bold'>Có thể sử dụng</p>
                        <div className='flex flex-wrap'>
                          {myGift.myGift.length > 0
                            ? myGift.myGift.map((i, index) => {
                                if (i?.eGift && new Date(i?.eGift?.expiredDate) >= new Date()) {
                                  return (
                                    <ItemGift
                                      data={i}
                                      key={uniqueId()}
                                      handleTypeGift={setTypeGift}
                                    />
                                  );
                                } else if (i?.eGift === null) {
                                  return (
                                    <ItemGift
                                      data={i}
                                      key={uniqueId()}
                                      handleTypeGift={setTypeGift}
                                    />
                                  );
                                }
                              })
                            : null}
                        </div>
                      </div>
                      <hr />
                      <div>
                        <p className='pt-2 font-averta-bold'>Không thể sử dụng</p>
                        <div className='flex flex-wrap'>
                          {myGift.myGift.length > 0
                            ? myGift.myGift.map((i) => {
                                if (i?.eGift && new Date(i?.eGift?.expiredDate) < new Date()) {
                                  return (
                                    <ItemGift
                                      expired
                                      data={i}
                                      key={uniqueId()}
                                      handleTypeGift={setTypeGift}
                                    />
                                  );
                                }
                              })
                            : null}
                        </div>
                      </div>
                    </ScrollArea>
                  </Tabs.TabPane>
                  <Tabs.TabPane tab='Đã sử dụng' key='2'>
                    <ScrollArea style={{ height: '400px' }}>
                      <div className='flex flex-wrap'>
                        {myGift.used.length > 0
                          ? myGift.used.map((i) => (
                              <ItemGift
                                used
                                data={i}
                                key={uniqueId()}
                                handleTypeGift={setTypeGift}
                              />
                            ))
                          : null}
                      </div>
                    </ScrollArea>
                  </Tabs.TabPane>
                </Tabs>
              </TabsStyle>
            </div>

            {/* modal 2 for use gift */}
            <ModalDetailUseGift
              statusGift={statusGift}
              type={typeGift.type}
              data={typeGift.data}
              handleClose={handleClose}
              handleStatusGift={setStatusGift}
              reloadData={reloadData}
            />
          </div>
          {/* success */}
          <NotifySuccess
            handleShowGift={handleShowGift}
            isSuccess={statusGift.isSuccess}
            name={typeGift.data?.giftTransaction?.giftName || ''}
            quantity={typeGift.data?.giftTransaction?.quantity || 1}
          />
          {/* falure */}
          <NotifyFailure
            handleClose={() => {
              setStatusGift((prev) => {
                return {
                  ...prev,
                  isFail: false,
                };
              });
            }}
            isFail={statusGift.isFail}
            name={typeGift.data?.giftTransaction?.giftName || ''}
            quantity={typeGift.data?.giftTransaction?.quantity || 1}
            resson={statusGift.reason}
          />
        </Modal>
      )}
    </>
  );
};
export default MyGiftModal;

const ItemGift = ({ data, used = false, expired = false, handleTypeGift }) => {
  const eGiftEmpty = isNullOrEmpty(data.eGift);
  const { date, month, year } = formatTimeString(
    !eGiftEmpty ? data.eGift.expiredDate : new Date().toISOString()
  );

  const [type, setType] = useState(0);
  const defineType = () => {
    if (!used) {
      if (
        data.giftTransaction.usageCheck === false &&
        data.giftTransaction.vendorName?.toLowerCase() === 'bvl_quabv - quà bảo việt'
      ) {
        setType(5);
        return;
      }
      if (
        (data.giftTransaction.usageCheck === false &&
          data.giftTransaction.vendorName?.toLowerCase() === 'urbox') ||
        data.giftTransaction.vendorName?.toLowerCase() !== 'urbox'
      ) {
        setType(3);
        return;
      }
      if (data.eGift === null && data.giftTransaction.status !== 'Delivered') {
        setType(2);
        return;
      }
      setType(1);
    } else {
      setType(4);
    }
  };

  const handleSetTypeGift = () => {
    handleTypeGift({ type, data });
  };

  const viewGift = () => {
    handleTypeGift({ type, data });
  };

  useEffect(() => {
    defineType();
  }, []);

  return (
    <div className={`my-3 mr-3 flex items-center`}>
      {used || expired ? (
        <div
          className={`${expired ? 'my-3 mr-3' : ''} flex cursor-pointer items-center ${
            used ? 'grow-0' : 'grow'
          }`}
          style={{
            filter: 'grayscale(1)',
          }}
          onClick={viewGift}
        >
          <img
            // src='assets/images/carousel/pc/Voucher2.png'
            src={data.imageLinks[0]?.fullLink || ''}
            alt=''
            className='mr-3 h-20 w-25 min-w-[100px] overflow-hidden rounded-lg'
          />
          <div className='mr-3'>
            <p className='text-15px line-clamp-3 h-14 w-full font-roboto-regular leading-18px lg:w-[140px]'>
              {data.giftTransaction.giftName || ''}
            </p>
            {!eGiftEmpty && (
              <p className='text-7B7B7B'>
                Thời hạn: {date}/{month}/{year}
              </p>
            )}
          </div>
        </div>
      ) : (
        <div
          className={`my-3 mr-3 flex items-center ${used ? 'grow-0' : 'grow'}`}
          style={{ filter: 'grayscale(0)' }}
        >
          <img
            // src='assets/images/carousel/pc/Voucher2.png'
            src={data.imageLinks[0]?.fullLink || ''}
            alt=''
            className='mr-3 h-20 w-25 min-w-[100px] overflow-hidden rounded-lg'
          />
          <div className='mr-3'>
            <p className='text-15px line-clamp-3 h-14 w-full font-roboto-regular leading-18px lg:w-[140px]'>
              {data.giftTransaction.giftName || ''}
            </p>
            {!eGiftEmpty && (
              <p className='text-7B7B7B'>
                Thời hạn: {date}/{month}/{year}
              </p>
            )}
          </div>
        </div>
      )}

      {!used && !expired && (
        <div>
          {type === 5 && (
            <button
              onClick={handleSetTypeGift}
              className='flex w-[86px] rounded-md border border-009565 px-1 py-[4px] text-left font-roboto-regular text-12px leading-3 text-009565 lg:w-[91px]'
            >
              <CheckOutlined
                style={{
                  fontSize: '16px',
                  padding: '0 2px',
                }}
              />
              <p>Nhập thông tin để nhận GYCBH</p>
            </button>
          )}
          {type === 3 && (
            <button
              onClick={handleSetTypeGift}
              className='flex w-[86px] rounded-md border border-009565 px-1 py-[4px] text-left font-roboto-regular text-12px leading-3 text-009565 lg:w-[91px]'
            >
              <CheckOutlined
                style={{
                  fontSize: '16px',
                  padding: '0 2px',
                }}
              />
              <p>Xác nhận nhận quà</p>
            </button>
          )}
          {type === 2 && (
            <button
              onClick={handleSetTypeGift}
              className='ml-5 flex w-fit rounded-md border border-009565 px-2 py-1 text-left font-roboto-regular text-12px leading-3 text-009565'
            >
              <p className='whitespace-nowrap'>Đang giao</p>
            </button>
          )}

          {type === 1 && (
            <button
              onClick={handleSetTypeGift}
              className='w-[86px] rounded-md bg-gradient-blue px-3 py-2.5 font-averta-semibold text-13px uppercase text-white lg:w-[91px]'
            >
              Sử dụng
            </button>
          )}
        </div>
      )}
      {expired && (
        <button
          type='button'
          style={{
            filter: 'grayscale(1)',
          }}
          className='ml-5 flex w-fit rounded-md border border-009565 px-2 py-1 text-left font-roboto-regular text-12px leading-3 text-009565'
        >
          <p className='whitespace-nowrap'>Hết hiệu lực</p>
        </button>
      )}
    </div>
  );
};
